import React from "react";

//import styles
import "./style.scss";

export default function Footer() {
  return <footer className="footerContent"></footer>;
}
